//TODO: should be web3 abstraction?
export enum TokenType {
    USDC = "USDC",
    MON = "MON"
}